export default __webpack_public_path__ + "static/media/date_picker_dropdown_arror.27adb4a7.svg";